import styled from "styled-components";
import {
    THEME_FONT_SIZE_SMALL,
    THEME_FONT_SIZE_MEDIUM,
    THEME_FONT_SIZE_LARGE,
    THEME_HIGH,
    THEME_MEDIUM,
    THEME_LOW,
} from "../../../reducers";

export const SIZE: Record<string, Record<string, string>> = {
    [THEME_FONT_SIZE_SMALL]: {
        fontSize: "18px",
        fontSizeQuran: "26px",
    },
    [THEME_FONT_SIZE_MEDIUM]: {
        fontSize: "21px",
        fontSizeQuran: "30px",
    },
    [THEME_FONT_SIZE_LARGE]: {
        fontSize: "24px",
        fontSizeQuran: "36px",
    },
};

export const THEME: Record<string, Record<string, Record<string, string>>> = {
    [THEME_HIGH]: {
        text: {
            color: "#000",
        },
        code: {
            color: "#000",
            bgColor: "#ffeb6a",
            borderColor: "#ffb106",
        },
        blockQuote: {
            color: "#ffb106",
            bgColor: "#371b0e",
        },
        a: {
            color: "#ffb106",
            hoverColor: "#ff7b11",
            focusColor: "#371b0e",
            focusBgColor: "#ffb106",
        },
    },
    [THEME_MEDIUM]: {
        text: {
            color: "#000",
        },
        code: {
            color: "#000",
            bgColor: "#bebebe",
            borderColor: "#989898",
        },
        blockQuote: {
            color: "#555555",
            bgColor: "#dcdcdc",
        },
        a: {
            color: "#4d8cf5",
            hoverColor: "#0068f5",
            focusColor: "#fff",
            focusBgColor: "#4d8cf5",
        },
    },
    [THEME_LOW]: {
        text: {
            color: "#fff",
        },
        code: {
            color: "#fff",
            bgColor: "#353839",
            borderColor: "#3f3f3f",
        },
        blockQuote: {
            color: "#fff",
            bgColor: "#3c3f40",
        },
        a: {
            color: "#4d8cf5",
            hoverColor: "#0068f5",
            focusColor: "#fff",
            focusBgColor: "#4d8cf5",
        },
    },
};

export const Container = styled.div`
    z-index: 1;
    position: relative;
`;

export const Generic = styled.div<{
    size: string;
    theme: string;
}>`
    z-index: 1;
    font-family: urdu, sans-serif;
    font-weight: 500;
    line-height: 200%;
    font-size: ${(p) => SIZE[p.size]["fontSize"]};
    color: ${(p) => THEME[p.theme]["text"]["color"]};

    padding: 15vh 5vw 8vh 5vw;
    overflow: hidden;
    overflow-y: auto;

    p:first-child {
        margin-top: 0;
    }

    @media (max-width: 1400px) {
    }
    @media (max-width: 1024px) {
    }

    @media (max-width: 600px) {
        column-count: 1;
        position: relative;
        left: auto;
        top: auto;
        right: auto;
        bottom: auto;
        width: 95%;
        margin: 100px auto 0 auto;

        overflow: auto;
    }

    span[text="ﷺ"],
    span[text="ؓ"],
    span[text="ؑ"] {
        font-size: 13px;
    }

    [lang="ar"],
    .quran-ayat {
        font-size: ${(p) => SIZE[p.size]["fontSizeQuran"]};
    }

    div,
    span {
        font-weight: 500;
        font-family: urdu, sans-serif;
    }

    ul > li {
        list-style-type: circle;
    }

    ol {
        list-style: arabic-indic;
    }

    img {
        cursor: pointer;
        max-width: 100%;
    }

    blockquote {
        margin: 40px 0;
        padding: 10px 20px;
        color: ${(p) => THEME[p.theme]["blockQuote"]["color"]};
        background-color: ${(p) => THEME[p.theme]["blockQuote"]["bgColor"]};

        * {
            font-weight: 500;
        }
    }

    code {
        display: block;
        direction: ltr;
        margin: 20px 0;
        padding: 15px 0 15px 15px;
        border-left: 4px solid ${(p) => THEME[p.theme]["code"]["borderColor"]};
        width: 100%;
        font-size: 15px;
        text-align: left;
        line-height: 150%;
        font-family: "Source Code Pro", monospace;
        color: ${(p) => THEME[p.theme]["code"]["color"]};
        background-color: ${(p) => THEME[p.theme]["code"]["bgColor"]};
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0 0 15px 0;
        font-weight: 700 !important;
        font-family: urdu, sans-serif;
    }
    h1 span,
    h2 span,
    h3 span,
    h4 span,
    h5 span,
    h6 span {
        font-family: urdu, sans-serif !important;
    }

    strong,
    b {
        font-weight: 700;
    }

    h1 {
        font-size: 30px;
    }

    h2 {
        font-size: 27px;
    }

    h3 {
        font-size: 24px;
    }

    h4 {
        font-size: 21px;
    }

    h5 {
        font-size: 18px;
    }

    h6 {
        font-size: 15px;
    }

    a {
        display: inline-block;
        color: ${(p) => THEME[p.theme]["a"]["color"]};
        text-decoration: none;

        &:hover,
        &:focus {
            outline: none;
            color: ${(p) => THEME[p.theme]["a"]["hoverColor"]};
        }

        img {
            background-color: #f00;
        }
    }

    .ltr-text {
        direction: ltr;
        font-family: Roboto, sans-serif;
        font-size: 17px;
    }

    .rtl-text {
        direction: rtl;
    }
`;

export const Poetry = styled(Generic)`
    overflow-x: hidden;
    overflow-y: auto;

    text-align: center;
    column-count: unset;
    column-fill: unset;
    column-width: unset;

    @media (max-width: 600px) {
        margin-top: 110px;
    }
`;
